<div class="h-100 color-dark flex-column w-100">
  <div class="image-wrapper relative w-100">
    <img class="background-image" ngSrc="assets/images/landing-pages-background.png" fill priority />
  </div>
  <div class="flex-column align-items-center p-5">
    <div class="text-28 bold-800 color-dark mb-5 text-center">
      Welcome to your <br />
      Mortgage Monitor
    </div>
    <span class="text-16 mb-5">Please enter your registered email address</span>
    <form [formGroup]="loginForm" class="flex-column gap-3 w-100" (ngSubmit)="login()">
      <div class="landing-responsive-row">
        <shared-form-field-wrapper class="w-100" label="E-mail" [formControl]="loginForm.controls.email" [hideRequiredIcon]="true">
          <shared-input-text [formControl]="loginForm.controls.email" name="login-email" type="email" />
        </shared-form-field-wrapper>
      </div>
      <div class="login-button-container">
        <button
          pButton
          type="submit"
          class="p-button p-button-primary w-100 centered"
          [activityLogClick]="AnalyticClickEventNames.landing.VERIFY_EMAIL"
          [disabled]="isCheckingLoginEmail$ | async"
          [loading]="isCheckingLoginEmail$ | async">
          Continue
        </button>
      </div>
    </form>
  </div>

  <div class="text-14 bold-800 color-primary text-center mb-5 mt-auto">
    <a [activityLogClick]="AnalyticClickEventNames.landing.CREATE_ACCOUNT" (click)="createAccount()" class="form-change-button pointer">
      Click here to create an account
    </a>
  </div>
</div>
